import React from "react";
import "./Footer.css";
import { useNavigate } from "react-router-dom";
import Instagram from "../assets/icons/Insta.svg";
import Facebook from "../assets/icons/Facebook.svg";
import Linkedin from "../assets/icons/Linkdin.svg";
import ArrowRight from "../assets/icons/footer-arrow-Icon.png.webp";
  import { Link } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleStoriesClick = () => {
    navigate("/about-us");
    setTimeout(() => {
      document.getElementById("stories-section")?.scrollIntoView({
        behavior: "smooth",
      });
    }, 300); // small delay to allow page to load
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section */}
        <div className="footer-left">
          {/* Frame 26 - Contains title, description, and input */}
          <div className="frame26">
            <h3 className="footer-title">
              Illuminate Your Future with{" "}
              <span className="highlight">Bixton.lk</span>
            </h3>
            <p className="footer-description">
              Get the latest news about <br /> artificial intelligence and green
              building
            </p>
            <div className="footer-input-container">
              <input
                type="email"
                placeholder="E-MAIL*"
                className="footer-input"
              />
              <button className="footer-button">
                <span className="arrow-right">
                  <img loading="lazy" decoding="async" src={ArrowRight} />
                </span>
              </button>
            </div>
          </div>

          {/* Footer Copyright Container */}
          <div className="footer-copyright-container">
            <p className="footer-copyright">
              © 2026 Bixton Lighting. All rights reserved.
            </p>
          </div>
        </div>

        {/* Right Section */}
        <div className="footer-right">
          <div className="footer-links">
            <div
              className="footer-column"
              onClick={() => navigate("/products")}
              style={{ cursor: "pointer" }}
            >
              <h4 className="footer-column-title">Products</h4>
              <img loading="lazy" decoding="async"
                src={ArrowRight}
                alt="Arrow Right"
                className="footer-arrow"
              />
            </div>
            <div
              className="footer-column"
              onClick={() => navigate("/about-us")}
              style={{ cursor: "pointer" }}
            >
              <h4 className="footer-column-title">Company</h4>
              <img loading="lazy" decoding="async"
                src={ArrowRight}
                alt="Arrow Right"
                className="footer-arrow"
              />
            </div>
            <div
              className="footer-column"
              onClick={handleStoriesClick}
              style={{ cursor: "pointer" }}
            >
              <h4 className="footer-column-title">Stories</h4>
              <img loading="lazy" decoding="async"
                src={ArrowRight}
                alt="Arrow Right"
                className="footer-arrow"
              />
            </div>
          </div>
          <div className="footer-info">
            <div className="footer-info-column">
              <p>Terms & Conditions</p>
            
              <Link
                to="/privacy-policy"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <p>Privacy Policy</p>
              </Link>
            </div>
            <div className="footer-info-column">
              <p>Get Direction</p>
              <p>Call Hotline</p>
            </div>
            <div className="footer-social-icons">
              <a
                href="https://www.instagram.com/bixtonlighting/?fbclid=IwY2xjawP2ertleHRuA2FlbQIxMQBicmlkETFjWDJsSzdSVUJ0aHVKMHRwc3J0YwZhcHBfaWQBMAABHngXqQWSjZVNeLVi2Vqomwz0ED3iO3LxgcANiCKPqkLAtIWwQV4F4-xGTYU7_aem_JmO2aIM60tHYsqEW-fscIA"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img loading="lazy" decoding="async" src={Instagram} alt="Instagram" />
              </a>

              <a
                href="https://www.linkedin.com/company/104098445/admin/dashboard/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img loading="lazy" decoding="async" src={Linkedin} alt="LinkedIn" />
              </a>

              <a
                href="https://www.facebook.com/BixtonInternationalPvtLimited"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img loading="lazy" decoding="async" src={Facebook} alt="Facebook" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
